// extracted by mini-css-extract-plugin
export default {"container":"EventVisibilityToggle_container__iF7X2","label":"EventVisibilityToggle_label__kQIrJ"};